var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafari(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5821 20.5821C21.1565 20.0078 21.4847 19.242 22.1411 17.7105L24.4758 12.2626C24.7104 11.7152 24.8277 11.4415 24.6932 11.3068C24.5586 11.1722 24.2849 11.2895 23.7375 11.5241L18.2895 13.8589C16.758 14.5153 15.9923 14.8435 15.4179 15.4179M20.5821 20.5821C20.0078 21.1565 19.242 21.4847 17.7105 22.1411L12.2626 24.4758C11.7152 24.7104 11.4415 24.8277 11.3068 24.6932C11.1722 24.5586 11.2895 24.2849 11.5241 23.7375L13.8589 18.2895C14.5153 16.758 14.8435 15.9923 15.4179 15.4179M20.5821 20.5821L15.4179 15.4179",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 18C33 26.2842 26.2842 33 18 33C9.71572 33 3 26.2842 3 18C3 9.71572 9.71572 3 18 3C26.2842 3 33 9.71572 33 18Z",
    stroke: "#03122E",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 3V5.25M18 33V30.75",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 18H30.75M3 18H5.25",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafari);
export default __webpack_public_path__ + "static/media/safari.3784d38dd8c74d62327e55ed8133acc7.svg";
export { ForwardRef as ReactComponent };